export default __webpack_public_path__ + "static/media/bannerImage2.50f44d0e.jpg";